var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.maintenance.active ? 'maintenance' : _vm.layout,{tag:"component"})
}
var staticRenderFns = []

export { render, staticRenderFns }